function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.0001 4.02234C9.39599 4.02234 4.17605 8.8399 4.17605 14.6259C4.17605 17.65 5.58953 20.3937 7.88731 22.3384L8.20849 22.6102L8.14389 23.026L7.58062 26.6517L11.4174 24.6537L11.6957 24.5087L11.9943 24.6052C13.2438 25.0088 14.5922 25.2294 16.0001 25.2294C22.6043 25.2294 27.8242 20.4118 27.8242 14.6259C27.8242 8.8399 22.6043 4.02234 16.0001 4.02234ZM2.67605 14.6259C2.67605 7.87106 8.71533 2.52234 16.0001 2.52234C23.2849 2.52234 29.3242 7.87106 29.3242 14.6259C29.3242 21.3806 23.2849 26.7294 16.0001 26.7294C14.5476 26.7294 13.1477 26.5181 11.8363 26.1267L6.9583 28.667L5.64314 29.3519L5.87077 27.8867L6.59834 23.2035C4.18663 21.022 2.67605 17.9913 2.67605 14.6259Z",
  fill: "#4C4C4C"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.94126 12.9891H22.0196C22.4263 12.9891 22.7554 12.6173 22.7554 12.1579C22.7554 11.6986 22.4263 11.3268 22.0196 11.3268H9.94126C9.53508 11.3268 9.20543 11.6986 9.20543 12.1579C9.20543 12.6173 9.53459 12.9891 9.94126 12.9891Z",
  fill: "#4C4C4C"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.99191 18.1514H19.1098C19.5443 18.1514 19.8961 17.7796 19.8961 17.3203C19.8961 16.8609 19.5443 16.4891 19.1098 16.4891H9.99191C9.55788 16.4891 9.20562 16.8609 9.20562 17.3203C9.20562 17.7796 9.55735 18.1514 9.99191 18.1514Z",
  fill: "#4C4C4C"
});

function SvgQueriesIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueriesIcon);
export default __webpack_public_path__ + "static/media/queriesIcon.0e688108.svg";
export { ForwardRef as ReactComponent };